// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e99bfc1a] .el-upload {\n  text-align: left !important;\n}\n.deleteStyle[data-v-e99bfc1a], .addStyle[data-v-e99bfc1a] {\n  font-size: 14px;\n  padding: 0 10px;\n}", ""]);
// Exports
module.exports = exports;
